<template>
  <div id="app">
      <pageheader></pageheader>
    <router-view/>
    <!-- <pagefooter></pagefooter> -->
  </div>
</template>

<script>
import topnav from './modules/topnav'
// import footernav from './modules/footernav'
export default {
  name: 'App',
  components:{
    "pageheader":topnav,
    // "pagefooter":footernav
  },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue